import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { Popover } from 'antd';
// import { BASE_API_URL } from '../services/baseServices';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import LogoImg from '../assets/Images/cwilogo.png';
import LogoImg1 from '../assets/Images/cwilogo1.png';
import { fetchWithAuth } from '../utils/api';

const MainLayout = ({ children }) => {

    const [sessionUserData, setSessionUserData] = useState([]);
    const [menuData, setMenuData] = useState([]);
    const [sessionModuleId, setSessionModuleId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem('userData');
        const moduleIdString = sessionStorage.getItem('ModuleId');
        
        setSessionModuleId(moduleIdString || 6);
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            console.log('User data not found in sessionStorage');
        }
    }, []);

    useEffect(() => {
        const orgId = sessionUserData?.OrgId;
        const roleId = sessionUserData?.RoleId;
    
        if (!orgId || !roleId || !sessionModuleId) return;
    
        const sessionKey = `menu_${orgId}_${roleId}_${sessionModuleId}`;
        const sessionMenu = sessionStorage.getItem(sessionKey);
    
        if (sessionMenu) {
            setMenuData(JSON.parse(sessionMenu));
        } else {
            const fetchMenu = async () => {
                try {
                    const response = await fetchWithAuth(`ADMINRoutes/getmenu?OrgId=${orgId}&RoleId=${roleId}&ModuleId=${sessionModuleId}&UserId=${sessionUserData?.Id}`, {
                        method: "GET",
                    });
                    const data = await response.json();
                    if (data?.ResultData) {
                        setMenuData(data.ResultData);
                        sessionStorage.setItem(sessionKey, JSON.stringify(data.ResultData));
                    }
                } catch (error) {
                    console.error("Failed to fetch menu:", error);
                }
            };
    
            fetchMenu();
        }
    }, [sessionUserData, sessionModuleId]);

    const handleLogout = async () => {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
    };
    
    return (
        <div className="main-wrapper">
            <div className="header">
                <div className="main-header">
                    <div className="header-left active">
                        <a className="logo logo-normal">
                            <img src="assets/img/logo.svg" alt="Img" />
                        </a>
                        <a className="logo logo-white">
                            <img src="assets/img/logo-white.svg" alt="Img" />
                        </a>
                        <a className="logo-small">
                            <img src="assets/img/logo-small.png" alt="Img" />
                        </a>
                    </div>

                    <a id="mobile_btn" className="mobile_btn" href="#sidebar">
                        <span className="bar-icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </a>

                    <ul className="nav user-menu">

                        <li className="nav-item nav-searchinputs">

                        </li>

                        {/* <li className="nav-item pos-nav">
                            <a href="pos.html" className="btn btn-dark btn-md d-inline-flex align-items-center">
                                <i className="ti ti-device-laptop me-1"></i>POS
                            </a>
                        </li> */}


                        <li className="nav-item nav-item-box">
                            <a >
                                <i className="ti ti-mail"></i>
                                <span className="badge rounded-pill">1</span>
                            </a>
                        </li>
                        <li className="nav-item dropdown nav-item-box">
                            <a className="dropdown-toggle nav-link" data-bs-toggle="dropdown">
                                <i className="ti ti-bell"></i>
                            </a>
                            <div className="dropdown-menu notifications">
                                <div className="topnav-dropdown-header">
                                    <h5 className="notification-title">Notifications</h5>
                                    <a href="javascript:void(0)" className="clear-noti">Mark all as read</a>
                                </div>
                                <div className="noti-content">
                                    <ul className="notification-list">
                                        <li className="notification-message">
                                            <a >
                                                <div className="media d-flex">
                                                    <span className="avatar flex-shrink-0">
                                                        <img alt="Img" src="assets/img/profiles/avatar-13.jpg" />
                                                    </span>
                                                    <div className="flex-grow-1">
                                                        <p className="noti-details"><span className="noti-title">James Kirwin</span> confirmed his order.  Order No: #78901.Estimated delivery: 2 days</p>
                                                        <p className="noti-time">4 mins ago</p>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="topnav-dropdown-footer d-flex align-items-center gap-3">
                                    <a href="#" className="btn btn-secondary btn-md w-100">Cancel</a>
                                    <a  className="btn btn-primary btn-md w-100">View all</a>
                                </div>
                            </div>
                        </li>

                        <li className="nav-item nav-item-box">
                            <a><i className="ti ti-settings"></i></a>
                        </li>
                        <li className="nav-item dropdown has-arrow main-drop profile-nav">
                            <a href="javascript:void(0);" className="nav-link userset" data-bs-toggle="dropdown">
                                <span className="user-info p-0">
                                    <span className="user-letter">
                                        <img src="assets/img/profiles/avator1.jpg" alt="Img" className="img-fluid" />
                                    </span>
                                </span>
                            </a>
                            <div className="dropdown-menu menu-drop-user">
                                <div className="profileset d-flex align-items-center">
                                    <span className="user-img me-2">
                                        <img src="assets/img/profiles/avator1.jpg" alt="Img" />
                                    </span>
                                    <div>
                                        <h6 className="fw-medium">{sessionUserData?.Name}</h6>
                                        <p>{sessionUserData?.RoleName}</p>
                                    </div>
                                </div>
                                <a className="dropdown-item"><i className="ti ti-user-circle me-2"></i>MyProfile</a>
                                {/* <a className="dropdown-item"><i className="ti ti-file-text me-2"></i>Reports</a> */}
                                <a className="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#theme-setting"><i className="ti ti-settings-2 me-2"></i>Settings</a>
                                <hr className="my-2" />
                                <span className="dropdown-item" onClick={handleLogout}>Logout</span>
                            </div>
                        </li>
                    </ul>

                    <div className="dropdown mobile-user-menu">
                        <a href="javascript:void(0);" className="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                            aria-expanded="false"><i className="fa fa-ellipsis-v"></i></a>
                        <div className="dropdown-menu dropdown-menu-right">
                            <a className="dropdown-item">My Profile</a>
                            <a className="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#theme-setting">Settings</a>
                            <span className="dropdown-item" onClick={handleLogout}>Logout</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="sidebar" id="sidebar">
                <div className="sidebar-logo">
                    <a className="logo logo-normal">
                        <img src={LogoImg} alt="Img" style={{ width: '12rem' }} />
                    </a>
                    <a className="logo logo-white">
                        <img src={LogoImg} alt="Img" style={{ width: '12rem' }} />
                    </a>
                    <a className="logo-small">
                        <img src={LogoImg1} alt="Img" style={{ width: '8rem' }} />
                    </a>
                    <a id="toggle_btn" href="javascript:void(0);">
                        <i data-feather="chevrons-left" className="feather-16"></i>
                    </a>
                </div>
                <div className="modern-profile p-3 pb-0">
                    <div className="text-center rounded bg-light p-3 mb-4 user-profile">
                        <div className="avatar avatar-lg online mb-3">
                            <img src="assets/img/customer/customer15.jpg" alt="Img" className="img-fluid rounded-circle" />
                        </div>
                        <h6 className="fs-14 fw-bold mb-1">Adrian Herman</h6>
                        <p className="fs-12 mb-0">System Admin</p>
                    </div>
                    <div className="sidebar-nav mb-3">
                        <ul className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent" role="tablist">
                            <li className="nav-item"><a className="nav-link active border-0" href="#">Menu</a></li>
                            <li className="nav-item"><a className="nav-link border-0">Chats</a></li>
                            <li className="nav-item"><a className="nav-link border-0">Inbox</a></li>
                        </ul>
                    </div>
                </div>
                <div className="sidebar-header p-3 pb-0 pt-2">
                    <div className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
                        <div className="avatar avatar-md onlin">
                            <img src="assets/img/customer/customer15.jpg" alt="Img" className="img-fluid rounded-circle" />
                        </div>
                        <div className="text-start sidebar-profile-info ms-2">
                            <h6 className="fs-14 fw-bold mb-1">Adrian Herman</h6>
                            <p className="fs-12">System Admin</p>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between menu-item mb-3">
                        <div>
                            <a className="btn btn-sm btn-icon bg-light">
                                <i className="ti ti-layout-grid-remove"></i>
                            </a>
                        </div>
                        <div>
                            <a className="btn btn-sm btn-icon bg-light">
                                <i className="ti ti-brand-hipchat"></i>
                            </a>
                        </div>
                        <div>
                            <a className="btn btn-sm btn-icon bg-light position-relative">
                                <i className="ti ti-message"></i>
                            </a>
                        </div>

                    </div>
                </div>
                <div className="sidebar-inner slimscroll">
                    <div id="sidebar-menu" className="sidebar-menu">
                        <ul>
                            <li className="submenu-open">
                                <h6 className="submenu-hdr">Main</h6>

                                <ul className="sidebar-menu">
                                    {menuData.map((menuItem) => (
                                        <li
                                            key={menuItem.AppMenuId}
                                            className="submenu"
                                            style={{ transition: 'transform 0.2s' }}
                                            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                        >
                                            <NavLink to={menuItem.MenuPath}>
                                                <i className={`${menuItem.IconName} fs-16 me-2`}></i>
                                                <span>{menuItem.MenuName}</span>
                                            </NavLink>

                                            {/* If submenu items exist */}
                                            {menuItem.SubItems && menuItem.SubItems.length > 0 && (
                                                <ul className="submenu-list">
                                                    {menuItem.SubItems.map((subItem) => (
                                                        <li key={subItem.AppMenuId}>
                                                            <NavLink to={subItem.MenuPath}>
                                                                <i className={`${subItem.IconName} fs-14 me-2`}></i>
                                                                {subItem.MenuName}
                                                            </NavLink>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                                {/* <ul>
                                    <li className="submenu"
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    >
                                        <a href="#" onClick={() => toggleMenu('dashboard')}>
                                            <i className="ti ti-layout-grid fs-16 me-2"></i>
                                            <span>Dashboard</span>
                                            <span className="menu-arrow"></span>
                                        </a>
                                        <ul className={openMenu === 'dashboard' ? 'show' : ''}>
                                            <li
                                                style={{
                                                    transition: 'transform 0.2s',
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                            ><a href="dashboard">Admin Dashboard</a></li>
                                            <li
                                                style={{
                                                    transition: 'transform 0.2s',
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                            ><a href="admin-dashboard.html">Admin Dashboard 2</a></li>
                                            <li
                                                style={{
                                                    transition: 'transform 0.2s',
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                            ><a href="sales-dashboard.html">Sales Dashboard</a></li>
                                        </ul>
                                    </li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/organizations`}><i className="ti ti-device-desktop fs-16 me-2"></i><span>Organizations</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/content-type`}><i className="ti ti-brand-unity fs-16 me-2"></i><span>Content Title</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/content-by-type`}><i className="ti ti-brand-unity fs-16 me-2"></i><span>Content By Type</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/products`}><i className="ti ti-brand-unity fs-16 me-2"></i><span>Products</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/categories`}><i className="ti ti-list-details fs-16 me-2"></i><span>Categories</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/brands`}><i className="ti ti-triangles fs-16 me-2"></i><span>Brand</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/users`}><i className="ti ti-users fs-16 me-2"></i><span>Users</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/departments`}><i className="fa-solid fa-sitemap me-2"></i><span>Departments</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/sections`}><i className="fa-solid fa-users-line me-2"></i><span>Sections</span></NavLink></li>
                                    <li
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    ><NavLink to={`/suppliers`}><i className="fa-solid fa-store me-2"></i><span>Suppliers</span></NavLink></li>
                                </ul> */}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="page-wrapper">
                {children}

                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0 text-gray-9">2025 &copy; CooperWind. All Right Reserved</p>
                    <p>Designed &amp; Developed by <a href="https://www.cooperwind.com/" target='_blank' className="text-primary">Cooperwind</a></p>
                </div>
            </div>

            <style>
                {`
                    .submenu ul {
                        display: none;
                    }

                    .submenu ul.show {
                        display: block;
                    }
                `}
            </style>
        </div>
    )
};

export default MainLayout;
